import 'client-only';

import { type Brand } from '@/consts/brands';
import {
  TreatmentCategoryIds,
  type TreatmentCategory,
} from '@/consts/treatmentCategories';
import {
  type GetBraintreeTokenData,
  type PayPalActivateExpressCheckoutTrialData,
} from '@/types/productSelectionAndCheckout/types';
import { get, post } from '@/utils/http/client';
import { urls } from '@/utils/urls';

const activateExpressCheckoutTrial = ({
  brand,
  data,
}: {
  brand: Brand;
  data: PayPalActivateExpressCheckoutTrialData;
}): Promise<void> =>
  post(urls[brand].api.payPal.activateExpressCheckoutTrial, data);

const activateExpressCheckoutSubscription = ({
  brand,
  data,
  treatmentCategory,
}: {
  brand: Brand;
  data: PayPalActivateExpressCheckoutTrialData;
  treatmentCategory: TreatmentCategory;
}): Promise<void> =>
  post(urls[brand].api.applePay.activateExpressCheckoutSubscription, {
    treatmentCategoryId: TreatmentCategoryIds[treatmentCategory],
    ...data,
  });

const getBraintreeToken = async ({
  brand,
}: {
  brand: Brand;
}): Promise<GetBraintreeTokenData> =>
  get(urls[brand].api.payPal.getBraintreeToken);

export const PayPalService = {
  activateExpressCheckoutTrial,
  activateExpressCheckoutSubscription,
  getBraintreeToken,
};
